export default "__VITE_ASSET__BYSrdLB4__"